var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary-post" }, [
    _c(
      "div",
      { staticClass: "summary-images social-image-slider" },
      [
        _c("SocialPostImageSlider", {
          attrs: { socialPost: _vm.socialPost, location: "summary" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "summary-caption" }, [
      _c("div", { staticClass: "platforms" }, [
        _c(
          "h4",
          _vm._l(_vm.socialPost.social_networks, function(network) {
            return _c("i", {
              class:
                "fab fa-" +
                _vm.getSocialNetworkSlugFromId(network) +
                " platform-indicator"
            })
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "caption" }, [
        _c("div", { staticClass: "caption-text" }, [
          !_vm.socialPost.caption
            ? _c("span", { staticClass: "no-caption" }, [_vm._v("No caption.")])
            : _vm._e(),
          _vm._v(" "),
          _vm.socialPost.caption
            ? _c("div", { staticClass: "caption-wrap" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.socialPost.caption) + "\n        "
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }